import { useState } from "react";
import { X, Mail, Lock, User, Building2 } from "lucide-react";
export function SignUpModal({
  onClose,
  onSignUp
}) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    role: ""
  });
  const handleSubmit = e => {
    e.preventDefault();
    onSignUp(formData);
  };
  return <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl max-w-md w-full">
        <div className="flex justify-between items-start p-6 border-b border-gray-100">
          <div>
            <h2 className="text-lg font-medium text-gray-900">
              Create your account
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Join the Michigan innovation ecosystem
            </p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="h-5 w-5" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                First Name
              </label>
              <input type="text" required value={formData.firstName} onChange={e => setFormData(prev => ({
              ...prev,
              firstName: e.target.value
            }))} className="w-full border border-gray-200 rounded-lg p-3 text-sm focus:ring-2 focus:ring-[#1D31FF] focus:border-transparent" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Last Name
              </label>
              <input type="text" required value={formData.lastName} onChange={e => setFormData(prev => ({
              ...prev,
              lastName: e.target.value
            }))} className="w-full border border-gray-200 rounded-lg p-3 text-sm focus:ring-2 focus:ring-[#1D31FF] focus:border-transparent" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Work Email
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
              <input type="email" required value={formData.email} onChange={e => setFormData(prev => ({
              ...prev,
              email: e.target.value
            }))} className="w-full pl-10 border border-gray-200 rounded-lg p-3 text-sm focus:ring-2 focus:ring-[#1D31FF] focus:border-transparent" placeholder="you@company.com" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Password
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
              <input type="password" required value={formData.password} onChange={e => setFormData(prev => ({
              ...prev,
              password: e.target.value
            }))} className="w-full pl-10 border border-gray-200 rounded-lg p-3 text-sm focus:ring-2 focus:ring-[#1D31FF] focus:border-transparent" placeholder="At least 8 characters" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Confirm Password
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
              <input type="password" required value={formData.confirmPassword} onChange={e => setFormData(prev => ({
              ...prev,
              confirmPassword: e.target.value
            }))} className="w-full pl-10 border border-gray-200 rounded-lg p-3 text-sm focus:ring-2 focus:ring-[#1D31FF] focus:border-transparent" placeholder="Confirm your password" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Company Name
            </label>
            <div className="relative">
              <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
              <input type="text" required value={formData.companyName} onChange={e => setFormData(prev => ({
              ...prev,
              companyName: e.target.value
            }))} className="w-full pl-10 border border-gray-200 rounded-lg p-3 text-sm focus:ring-2 focus:ring-[#1D31FF] focus:border-transparent" placeholder="Your company name" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Your Role
            </label>
            <select required value={formData.role} onChange={e => setFormData(prev => ({
            ...prev,
            role: e.target.value
          }))} className="w-full border border-gray-200 rounded-lg p-3 text-sm focus:ring-2 focus:ring-[#1D31FF] focus:border-transparent">
              <option value="">Select your role</option>
              <option value="founder">Founder/Co-founder</option>
              <option value="investor">Investor</option>
              <option value="employee">Employee</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div>
            <button type="submit" className="w-full px-4 py-3 bg-[#1D31FF] text-white rounded-lg font-medium hover:bg-[#1D31FF]/90">
              Create Account
            </button>
            <p className="mt-4 text-center text-sm text-gray-600">
              Already have an account?{" "}
              <button type="button" onClick={onClose} className="text-[#1D31FF] font-medium hover:text-[#1D31FF]/90">
                Log in
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>;
}